// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1R4Ss","validationTips":"StatementDescriptor_validationTips__199T0"};